import { render, staticRenderFns } from "./ChannelHeader.vue?vue&type=template&id=00570c5d&scoped=true&"
import script from "./ChannelHeader.vue?vue&type=script&lang=js&"
export * from "./ChannelHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChannelHeader.vue?vue&type=style&index=0&id=00570c5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00570c5d",
  null
  
)

export default component.exports